export const getStarClassName = (rating) => {
    switch (true) {
        case rating > 0.75:
            return 'full-star';
        case rating >= 0.25 && rating <= 0.75:
            return 'half-star';
        case rating < 0.25:
            return 'empty-star';
    }
};

export const getStarValues = (rating) => {
    const starRating = [0, 0, 0, 0, 0];

    starRating.forEach((value, index) => {
        starRating[index] = getStarClassName(Math.min(1, rating - index));
    });

    return starRating;
};
